// import { useQuery } from '@tanstack/react-query'
import { statementsApi } from '../../api'
import { useAuthQuery } from '@/hooks/use-auth-query'

export function useAccountSummary() {
  return useAuthQuery({
    queryKey: ['account_summary'],
    queryFn: statementsApi.getAccountSummary,
    refetchOnWindowFocus: true,
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
  })
}
